import type { GetStaticPaths, GetStaticProps } from 'next'
import Anniversary7 from '~/components/Campaign/Anniversary7'
import NewYear from '~/components/Campaign/NewYear'
import { HOST } from '~/constants/host'
import i18n from '~/i18n'

const ALLOWED = ['newyear', '7th-anniversary'] as const
type Slug = typeof ALLOWED[number]
const ANNIVERSARY_PATH = '/campaign/7th-anniversary'
const ANNIVERSARY_OG_IMAGE = '/images/tokenlon-7th-og-banner.jpg'

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALLOWED.map((slug) => ({ params: { slug } })),
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps<{ slug: Slug }> = async (ctx) => {
  const slug = ctx.params?.slug

  if (!slug || typeof slug !== 'string' || !ALLOWED.includes(slug as Slug)) {
    return { notFound: true }
  }

  const anniversaryTitle = i18n.t('anniversary7.meta_title')
  const anniversaryDescription = i18n.t('anniversary7.meta_description')

  return {
    props: {
      slug: slug as Slug,
      openGraphData:
        slug === '7th-anniversary'
          ? [
              {
                property: 'og:url',
                content: `${HOST}${ANNIVERSARY_PATH}`,
                key: 'ogurl',
              },
              {
                property: 'og:title',
                content: anniversaryTitle,
                key: 'ogtitle',
              },
              {
                property: 'og:description',
                content: anniversaryDescription,
                key: 'ogdesc',
              },
              {
                property: 'og:image',
                content: `${HOST}${ANNIVERSARY_OG_IMAGE}`,
                key: 'ogimage',
              },
              {
                name: 'twitter:title',
                content: anniversaryTitle,
                key: 'twtitle',
              },
              {
                name: 'twitter:description',
                content: anniversaryDescription,
                key: 'twdesc',
              },
              {
                name: 'twitter:image',
                content: `${HOST}${ANNIVERSARY_OG_IMAGE}`,
                key: 'twimage',
              },
            ]
          : [],
    },
  }
}

export default function CampaignPage({ slug }: { slug: Slug }) {
  if (slug === 'newyear') return <NewYear />
  if (slug === '7th-anniversary') return <Anniversary7 />
  return null
}
